export const SET_DRIVERS = "@@app/SET_DRIVERS";
export const RESET_DATA_DRIVERS = "@@app/RESET_DATA_DRIVERS";
export const SET_DATA_DRIVER = "@@app/SET_DATA_DRIVER";
export const SET_DATA_DRIVER_KEY_STATE = "@@app/SET_DATA_DRIVER_KEY_STATE";
export const RESET_DATA_NEW_USER = "@@app/RESET_DATA_NEW_USER";
